import dayjs from 'dayjs'

// Returns number string with x decimal places
export function fixed (value:any, decimals?:any) {
  if (typeof value === 'number' && value !== null && value % 1 !== 0 && value !== undefined && !(isNaN(value))) {
    return decimals !== undefined ? parseFloat(value.toFixed(decimals)) : parseFloat(value.toFixed(2))
  }
  return value
}

// Rounds number to x precisions
export function roundToPrecision (value:any, precision?:number) {
  let y = value + (precision === undefined ? 0.5 : precision / 2)
  return y - (y % (precision === undefined ? 1 : precision))
}

// Adds $ symbol to + / - number strings
export function money (value:any) {
  if (value < 0) {
    let newValue = value.toString().substr(1, value.length)
    return '-$' + Number(newValue).toLocaleString(undefined, { minimumFractionDigits: 2 })
  }
  return '$' + Number(value).toLocaleString(undefined, { minimumFractionDigits: 2 })
}

// Adds % symbol to number string
export function percentage (value:any) {
  if (value) {
    return value + '%'
  }
}

// Formats dates
export function formatDate (value:any, format?:string) {
  if (format) {
    return dayjs(value).format(format)
  }
  return value
}
